// import { BLUECONIC_SITES } from './BLUECONIC_SITES.const';

export const hasOAuth = (
  type: 'google-oauth' | 'microsoft-oauth',
  propertyEndpoint?: string,
  experiments?: string[],
  isFannation = false,
): boolean => {
  if (!propertyEndpoint) return false;

  const hasSuppressedExperiment = experiments?.some(experiment => experiment.includes('google-oauth') && experiment.includes('suppression'));

  if (hasSuppressedExperiment) return false;

  const hasExperiment = experiments?.some(
    experiment => (experiment.includes(type) && experiment.includes('modal'))
  );

  // This will contain more properties as needed.
  const properties = ['www.si.com'];

  if (type === 'google-oauth') {
    return hasExperiment || false;
  }
  // microsoft-oauth
  if (type === 'microsoft-oauth') {
    return (
      hasExperiment
      || properties.some(property => propertyEndpoint.includes(property))
      || isFannation
    );
  }

  return false;
};
